module.exports = __webpack_public_path__ + "assets/598bf274a411e0c9e5745a71b22dd9ba.mp3";